import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import api from "../api";

const BASE = "FILA Gestão";
const RESERVED = new Set([
  "", "super", "entrar", "support", "api", "static", "assets",
  "login", "logout", "fila", "tv", "relatorios", "historico",
  "profissionais", "recepcao", "configuracoes", "personalizacao",
  "minha-vez", "meu-status",
]);

// Cache in-memory dos display_names por slug (evita refetch a cada navegação)
const slugCache = new Map();

/**
 * Ajusta document.title dinamicamente conforme a rota:
 *  - "/", "/entrar", "/support/enter"  -> "FILA Gestão"
 *  - "/super/*"                        -> "FILA Gestão | Super Admin"
 *  - "/:tenantSlug/*"                  -> "FILA Gestão | {display_name}"
 * Não altera favicon (global) nem toca em regras operacionais.
 */
export default function DocumentTitle() {
  const location = useLocation();
  const { tenant } = useAuth();
  const [slugName, setSlugName] = useState(null);

  const firstSeg = (location.pathname.split("/")[1] || "").toLowerCase();
  const isSuper = firstSeg === "super";
  const isTenantRoute = firstSeg && !RESERVED.has(firstSeg);
  const slug = isTenantRoute ? firstSeg : null;

  useEffect(() => {
    if (!slug) { setSlugName(null); return; }
    // Se tenant logado bate com o slug, usa direto
    if (tenant && tenant.slug === slug && (tenant.display_name || tenant.name)) {
      setSlugName(tenant.display_name || tenant.name);
      return;
    }
    // Cache hit
    if (slugCache.has(slug)) {
      setSlugName(slugCache.get(slug));
      return;
    }
    let cancel = false;
    api.get(`/tenants/${slug}/public`)
      .then(({ data }) => {
        if (cancel) return;
        const name = data?.display_name || data?.name || null;
        if (name) slugCache.set(slug, name);
        setSlugName(name);
      })
      .catch(() => { if (!cancel) setSlugName(null); });
    return () => { cancel = true; };
  }, [slug, tenant]);

  useEffect(() => {
    let title = BASE;
    if (isSuper) {
      title = `${BASE} | Super Admin`;
    } else if (slug) {
      title = slugName ? `${BASE} | ${slugName}` : BASE;
    }
    if (document.title !== title) document.title = title;
  }, [isSuper, slug, slugName]);

  return null;
}
